export default {
  listSector: [],
  sector: {
    id: 0,
    ativo: true,
    nome: '',
  },
}
